
import { Product } from '@/types/product';

export const products: Product[] = [
  {
    id: '1',
    name: 'Premium Wireless Headphones',
    description: 'Experience studio-quality sound with these premium wireless headphones. Featuring active noise cancellation, 30-hour battery life, and ultra-comfortable ear cushions.',
    price: 299.99,
    discount: 10,
    category: 'Electronics',
    // imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=2070&auto=format&fit=crop',
    imageUrl: 'https://img.freepik.com/premium-photo/cricket-batsman-action-professional-cricket-stadium_1456-3847.jpg?ga=GA1.1.632904872.1748259989&semt=ais_items_boosted&w=1080',
    rating: 4.8,
    reviews: 126,
    isNew: true,
    forRent: true,
    rentalPrice: 15.99,
    stock: 25,
    colors: ['Black', 'Silver', 'Blue'],
    features: [
      'Active Noise Cancellation',
      'Bluetooth 5.2',
      '30-hour battery life',
      'High-resolution audio',
      'Voice assistant compatible'
    ]
  },
  {
    id: '2',
    name: 'Professional DSLR Camera with 24-70mm Lens',
    description: 'Capture breathtaking photos and videos with this professional-grade DSLR camera. Includes a versatile 24-70mm lens, perfect for everything from portraits to landscapes.',
    price: 1299.99,
    discount: 0,
    category: 'Photography',
    imageUrl: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?q=80&w=2138&auto=format&fit=crop',
    rating: 4.9,
    reviews: 87,
    isNew: false,
    forRent: true,
    rentalPrice: 49.99,
    stock: 10,
    colors: ['Black'],
    features: [
      '45.7 megapixel full-frame sensor',
      '4K video recording',
      'Weather-sealed body',
      'Dual SD card slots',
      'Touchscreen LCD'
    ]
  },
  {
    id: '3',
    name: 'Smart Fitness Watch',
    description: 'Track your fitness goals with precision. This smartwatch monitors heart rate, sleep patterns, and activity levels while providing smartphone notifications.',
    price: 199.99,
    discount: 20,
    category: 'Wearables',
    imageUrl: 'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?q=80&w=2072&auto=format&fit=crop',
    rating: 4.6,
    reviews: 215,
    isNew: true,
    forRent: false,
    stock: 50,
    colors: ['Black', 'White', 'Rose Gold'],
    features: [
      'Heart rate monitoring',
      'GPS tracking',
      'Water resistant to 50m',
      '7-day battery life',
      'Sleep tracking'
    ]
  },
  {
    id: '4',
    name: 'Ergonomic Office Chair',
    description: 'Work in comfort with this premium ergonomic office chair, designed to provide maximum support during long hours at your desk.',
    price: 349.99,
    discount: 0,
    category: 'Furniture',
    imageUrl: 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?q=80&w=2071&auto=format&fit=crop',
    rating: 4.7,
    reviews: 64,
    isNew: false,
    forRent: true,
    rentalPrice: 12.99,
    stock: 15,
    colors: ['Black', 'Gray'],
    features: [
      'Adjustable lumbar support',
      'Breathable mesh back',
      'Adjustable armrests',
      'Swivel base with smooth-rolling casters',
      'Weight capacity: 300 lbs'
    ]
  },
  {
    id: '5',
    name: 'Portable Bluetooth Speaker',
    description: 'Take your music anywhere with this waterproof, portable Bluetooth speaker. Features 360° sound and 20 hours of battery life.',
    price: 129.99,
    discount: 15,
    category: 'Electronics',
    imageUrl: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?q=80&w=2069&auto=format&fit=crop',
    rating: 4.5,
    reviews: 187,
    isNew: false,
    forRent: false,
    stock: 40,
    colors: ['Black', 'Blue', 'Red'],
    features: [
      'IPX7 waterproof',
      '20-hour battery life',
      'Built-in microphone for calls',
      'Connect multiple speakers',
      'USB-C charging'
    ]
  },
  {
    id: '6',
    name: 'Professional Drone with 4K Camera',
    description: 'Explore the skies and capture stunning aerial footage with this professional drone featuring a stabilized 4K camera and 30-minute flight time.',
    price: 899.99,
    discount: 0,
    category: 'Electronics',
    imageUrl: 'https://images.unsplash.com/photo-1506947411487-a56738267384?q=80&w=2070&auto=format&fit=crop',
    rating: 4.8,
    reviews: 52,
    isNew: true,
    forRent: true,
    rentalPrice: 39.99,
    stock: 8,
    colors: ['Gray'],
    features: [
      '4K/60fps video',
      '3-axis gimbal stabilization',
      '30-minute flight time',
      'Object tracking',
      '8km transmission range'
    ]
  },
  {
    id: '7',
    name: 'Artisan Coffee Maker',
    description: 'Brew barista-quality coffee at home with this premium coffee maker. Features precision temperature control and customizable brewing options.',
    price: 179.99,
    discount: 0,
    category: 'Kitchen',
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?q=80&w=2070&auto=format&fit=crop',
    rating: 4.7,
    reviews: 103,
    isNew: false,
    forRent: false,
    stock: 20,
    colors: ['Silver', 'Black'],
    features: [
      'Precise temperature control',
      'Multiple brew strengths',
      'Programmable timer',
      '12-cup capacity',
      'Built-in grinder'
    ]
  },
  {
    id: '8',
    name: 'Electric Longboard',
    description: 'Cruise in style with this electric longboard. Featuring dual motors, a 22-mile range, and a top speed of 25 mph.',
    price: 699.99,
    discount: 10,
    category: 'Sports & Outdoors',
    imageUrl: 'https://images.unsplash.com/photo-1533603547086-89920971d258?q=80&w=2070&auto=format&fit=crop',
    rating: 4.6,
    reviews: 39,
    isNew: true,
    forRent: true,
    rentalPrice: 29.99,
    stock: 12,
    colors: ['Black', 'Wood'],
    features: [
      'Dual 750W motors',
      '22-mile range',
      'Top speed: 25 mph',
      'Regenerative braking',
      'Wireless remote control'
    ]
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsByCategory = (category: string): Product[] => {
  return products.filter(product => product.category === category);
};

export const getProductsForRent = (): Product[] => {
  return products.filter(product => product.forRent);
};

export const getNewProducts = (): Product[] => {
  return products.filter(product => product.isNew);
};

export const getDiscountedProducts = (): Product[] => {
  return products.filter(product => product.discount > 0);
};
